import { postRequest } from './authHttpClient';
import { config } from '../utils/apiConfig';
const resourceUrl = `${config.API_URL}/artistrequest/`;

export const sendRequest = async (reqData) => {
  return postRequest(resourceUrl, reqData);
};
